import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceAreaRequests} from "../../services/service-area-requests.service";

export class ServiceAreaSelectOldCtrl implements IController {
  title: string;
  areaList: any;
  selected: any;
  isLoading: boolean;
  isAddress: boolean;
  onSelectChange: Function;

  public areaListCopy: any;
  public search: any;

  constructor(private splitService, private serviceAreaRequests: ServiceAreaRequests, private $log) {
  }

  $onInit() {

    this.areaListCopy = angular.copy(this.areaList);
    this.search = {
      query: '',
      address: undefined,
      areas: [],
      options: {
        country: this.splitService.getCountryCode(),
        types: 'address',
        language: this.splitService.getLocaleCode(),
        watchEnter: true
      }
    };

    _.forEach(this.selected, (selected) => {
      const selectedAreaIndex = _.findIndex(this.areaListCopy, (area: any) => {
        return _.isEqual(area.areaId, selected);
      });

      if (!_.isEqual(selectedAreaIndex, -1)) {
        const selectedArea = this.areaListCopy[selectedAreaIndex];
        this.areaListCopy.splice(selectedAreaIndex, 1);
        this.areaListCopy.unshift(selectedArea);
      }
    });
  }

  addressSelected(address) {
    if (!_.isEmpty(address.address)) {
      this.isLoading = true;

      const lat = address.address.location.lat;
      const lng = address.address.location.lng;

      this.serviceAreaRequests.searchAreasByAddressGeoLocation(lat, lng).then(
        (areas) => {
          this.isLoading = false;
          this.search.areas = areas;
        }).catch(
        (error) => {
          this.isLoading = false;
          this.$log.debug(error);
        });
    } else {
      this.search.areas = [];
    }
  }

  selectAll() {
    this.selected = _.map(this.areaList, (area) => {
      return area.areaId;
    });
  }

  reset() {
    this.selected = [];
  }

  clear() {
    this.search.address = undefined;
    this.search.query = '';
    this.search.areas = [];
  }

  addArea(areaId) {
    const areaIndexInList = this.selected.indexOf(areaId);
    if (areaIndexInList !== -1) {
      this.selected.splice(areaIndexInList, 1);
    } else {
      this.selected.push(areaId);
    }

    this.onSelectChange({areaIds: this.selected});
  }


}

angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreaSelectOld', {
    bindings: {
      title: '<',
      areaList: '<',
      selected: '=',
      isLoading: '<',
      isAddress: '<',
      onSelectChange: '&'
    },
    template: require('./service-area-select-old.html').default,
    controller: ServiceAreaSelectOldCtrl
  });
